const tpoRoofing = [
  {
    question: "What is TPO roofing and what is it made of?",
    answer:
      "TPO roofing stands for thermoplastic polyolefin, a single-ply membrane made from polypropylene and ethylene-propylene rubber. It's engineered for durability, UV resistance, and energy efficiency — ideal for flat or low-slope roofs <IN_CITY_ZIP>.",
  },
  {
    question: "How long does a TPO roof last?",
    answer:
      "A professionally installed TPO roof typically lasts 20 to 30 years <IN_CITY_ZIP>. Regular maintenance can extend its lifespan and performance against sun, rain, and temperature swings.",
  },
  {
    question: "Do I need a permit to install or replace a TPO roof?",
    answer:
      "Yes. TPO roof installations require city permits and inspections in most jurisdictions <IN_CITY_ZIP>. Modern Build manages all permitting and compliance to keep your project hassle-free.",
  },
  {
    question: "How long does TPO roofing installation take?",
    answer:
      "Installation usually takes 3 to 5 days depending on roof size, prep work, and weather conditions <IN_CITY_ZIP>. You'll receive a precise timeline during your free estimate visit.",
  },
  {
    question: "Is TPO roofing good for hot and sunny climates?",
    answer:
      "Absolutely. TPO roofs are Energy Star-rated and reflect UV rays, which helps reduce rooftop heat buildup and lower indoor cooling costs <IN_CITY_ZIP>.",
  },
  {
    question: "What types of TPO roof systems do you install?",
    answer:
      "We install fully adhered, mechanically fastened, and ballasted TPO roofing systems. We’ll recommend the best system for your building based on structure, budget, and efficiency goals <IN_CITY_ZIP>.",
  },
  {
    question: "Can you install TPO roofing over an existing roof?",
    answer:
      "In some cases, yes. If the current roof is in good condition and meets code, a TPO overlay may be an option. We conduct a detailed inspection to determine the safest and most cost-effective path <IN_CITY_ZIP>.",
  },
  {
    question: "How much does TPO roofing cost?",
    answer:
      "TPO roofing typically ranges from $8,000 to $18,000+ depending on roof size, insulation type, and installation method <IN_CITY_ZIP>. We provide upfront, customized quotes with no hidden fees.",
  },
  {
    question: "Are TPO roofs fire-resistant?",
    answer:
      "Yes. TPO membranes meet Class A fire resistance ratings when installed over a fire-rated substrate, making them a safe option for both commercial and residential buildings <IN_CITY_ZIP>.",
  },
  {
    question: "What kind of maintenance does a TPO roof need?",
    answer:
      "TPO roofs require minimal upkeep. We recommend semi-annual inspections to check seams, drains, and flashings. Cleaning debris and resealing joints helps extend lifespan and performance <IN_CITY_ZIP>.",
  },
  {
    question: "Is TPO roofing suitable for both residential and commercial properties?",
    answer:
      "Yes. TPO is widely used for both commercial buildings and modern residential flat roofs <IN_CITY_ZIP>. It's a durable, energy-efficient solution ideal for long-term savings and low maintenance.",
  },
  {
    question: "Do you offer warranties on TPO roofing systems?",
    answer:
      "Yes. We offer manufacturer warranties of 15 to 30 years depending on the membrane thickness, plus our own workmanship warranty for added peace of mind <IN_CITY_ZIP>.",
  },
];

export default tpoRoofing;
